import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './spinner-universal-turning/HeroSection';
import { SpecsSection } from './spinner-universal-turning/SpecsSection';
import { MachineModelsSection } from './spinner-universal-turning/MachineModelsSection';
export function SpinnerUniversalTurningPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-4021">
      <SeoBar data-id="element-4022" />
      <Header data-id="element-4023" />
      <main className="flex-grow" data-id="element-4024">
        <div className="w-full bg-white pb-20" data-id="element-4025">
          <HeroSection data-id="element-4026" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-4027">
            <SpecsSection data-id="element-4028" />
            <MachineModelsSection data-id="element-4029" />
          </div>
        </div>
      </main>
      <Footer data-id="element-4030" />
    </div>;
}